import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { DashboardWidgetListStore } from "../../store/DashboardWidgetListStore";

type DashboardWidgetListDialogsProps = {
  store: DashboardWidgetListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de DashboardWidget.
 * Separado para mantener DashboardWidgetListPage más limpio.
 */
export const DashboardWidgetListDialogs: React.FC<DashboardWidgetListDialogsProps> =
  observer(({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  });
